import { SUBCATEGORY_INITIAL_STATE } from './chunk-YTGMKKOP.mjs';
import { getCategoryChildrenType } from './chunk-F6KAEMDT.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import has from 'lodash/has';

var getHasAllSubcategory = (subcategoryMenuTypeItemsIds, subcategoryMenuTypeCombosIds, currentMenuTypeId) => (has(subcategoryMenuTypeItemsIds, `0.${currentMenuTypeId}`) || has(subcategoryMenuTypeCombosIds, `0.${currentMenuTypeId}`)) && getCategoryChildrenType(
  subcategoryMenuTypeItemsIds || {},
  subcategoryMenuTypeCombosIds || {}
) === "subcategory" /* SUBCATEGORY */;
var mapSubcategoryFromBucket = (subcategoriesIds, subcategories) => {
  return subcategoriesIds.filter((id) => id > 0).map((subcategoryId) => subcategories[subcategoryId]).filter((subcategory) => {
    return subcategory.active;
  });
};
var filterSubcategoriesWithItemAndComboIdSet = (subcategories, existentItemIds, existentComboIds, items, combos, menuTypeIdString, currentCategoryId, categoryBucket) => {
  var _a, _b, _c, _d, _e, _f;
  if (!menuTypeIdString)
    return [];
  const menuTypeId = Number(menuTypeIdString);
  const category = currentCategoryId ? categoryBucket[currentCategoryId] : null;
  const hasAllSubcategory = currentCategoryId && getHasAllSubcategory(
    (category == null ? void 0 : category.subcategoryMenuTypeItemsIds) || {},
    (category == null ? void 0 : category.subcategoryMenuTypeCombosIds) || {},
    menuTypeId
  );
  const allSubcategory = __spreadProps(__spreadValues({}, SUBCATEGORY_INITIAL_STATE), {
    name: "All",
    posName: "All",
    maxPrice: 0,
    minPrice: Infinity,
    itemIds: (_c = (_b = (_a = category == null ? void 0 : category.subcategoryMenuTypeItemsIds) == null ? void 0 : _a[0]) == null ? void 0 : _b[menuTypeId]) != null ? _c : [],
    comboIds: (_f = (_e = (_d = category == null ? void 0 : category.subcategoryMenuTypeCombosIds) == null ? void 0 : _d[0]) == null ? void 0 : _e[menuTypeId]) != null ? _f : []
  });
  const subcategoriesArray = subcategories.map((subcategory) => {
    if (!Object.keys(subcategory.menuTypeItemIds).some(
      (menuTypeItemKey) => Number(menuTypeItemKey) === menuTypeId
    ))
      return __spreadProps(__spreadValues({}, subcategory), {
        itemIds: [],
        comboIds: [],
        maxPrice: null,
        minPrice: null
      });
    const filteredItemIds = subcategory.itemIds.filter((itemId) => {
      return existentItemIds.has(itemId) && items[itemId].menuTypeVersions[menuTypeId].active;
    });
    const filteredComboIds = subcategory.comboIds.filter(
      (comboId) => existentComboIds.has(comboId) && combos[comboId].menuTypeVersions[menuTypeId].active
    );
    const itemsPriceRange = filteredItemIds.reduce(
      (acc, itemId) => {
        const item = items[itemId];
        const itemMenuTypeVersion = item.menuTypeVersions[menuTypeId];
        const { itemPrice } = itemMenuTypeVersion;
        return {
          maxPrice: Math.max(acc.maxPrice, itemPrice),
          minPrice: Math.min(acc.minPrice, itemPrice)
        };
      },
      { maxPrice: 0, minPrice: Infinity }
    );
    const { maxPrice, minPrice } = filteredComboIds.reduce((acc, comboId) => {
      const combo = combos[comboId];
      const comboMenuTypeVersion = combo.menuTypeVersions[menuTypeId];
      const { comboBasePrice } = comboMenuTypeVersion;
      return {
        maxPrice: Math.max(acc.maxPrice, comboBasePrice),
        minPrice: Math.min(acc.minPrice, comboBasePrice)
      };
    }, itemsPriceRange);
    if (hasAllSubcategory) {
      allSubcategory.itemIds = [
        ...allSubcategory.itemIds,
        ...filteredItemIds
      ];
      allSubcategory.comboIds = [
        ...allSubcategory.comboIds,
        ...filteredComboIds
      ];
    }
    return __spreadProps(__spreadValues({}, subcategory), {
      itemIds: filteredItemIds,
      comboIds: filteredComboIds,
      maxPrice: maxPrice === 0 ? null : maxPrice,
      minPrice: minPrice === Infinity ? null : minPrice
    });
  }).filter((subcategory) => {
    const hasElements = !!subcategory.itemIds.length || !!subcategory.comboIds.length;
    const hasActiveElements = subcategory.itemIds.some(
      (itemId) => {
        var _a2, _b2;
        return Object.values(
          (_b2 = (_a2 = items[itemId].menuTypeVersions[menuTypeId]) == null ? void 0 : _a2.categoriesSubcategories) != null ? _b2 : {}
        ).some((catSubcat) => Boolean(catSubcat.categoryId));
      }
    ) || subcategory.comboIds.some(
      (comboId) => {
        var _a2, _b2;
        return Object.values(
          (_b2 = (_a2 = combos[comboId].menuTypeVersions[menuTypeId]) == null ? void 0 : _a2.categoriesSubcategories) != null ? _b2 : {}
        ).some((catSubcat) => Boolean(catSubcat.categoryId));
      }
    );
    return hasElements && hasActiveElements;
  }).sort((a, b) => a.sortPriority - b.sortPriority);
  return hasAllSubcategory ? [allSubcategory, ...subcategoriesArray] : subcategoriesArray;
};
var filterMenuCategoriesAndSubCategories = (selectedMenuType, itemsInMenuType, combosInMenuType, categories, subcategories, items, combos) => {
  var _a;
  if (!selectedMenuType)
    return [];
  const selectedMenuTypeId = selectedMenuType.menuTypeId;
  const categoryIds = (_a = selectedMenuType.categoryIds) != null ? _a : [];
  return categoryIds.map((categoryId) => {
    return categories[categoryId];
  }).filter((category) => category.active).reduce(
    (filteredCategories, category) => {
      const {
        subcategoryMenuTypeItemsIds,
        itemIds,
        subcategoryMenuTypeCombosIds,
        comboIds,
        categoryId
      } = category;
      const childrenType = getCategoryChildrenType(
        subcategoryMenuTypeItemsIds,
        subcategoryMenuTypeCombosIds
      );
      if (childrenType === "item" /* ITEM */) {
        const hasElements = itemIds.some(
          (itemId) => itemsInMenuType.has(itemId) && items[itemId].menuTypeVersions[selectedMenuTypeId].active
        ) || comboIds.some(
          (comboId) => combosInMenuType.has(comboId) && combos[comboId].menuTypeVersions[selectedMenuTypeId].active
        );
        if (!hasElements)
          return filteredCategories;
        else
          return __spreadProps(__spreadValues({}, filteredCategories), {
            [categoryId]: category
          });
      }
      const filteredSubcategories = filterSubcategoriesWithItemAndComboIdSet(
        mapSubcategoryFromBucket(
          Object.keys(__spreadValues(__spreadValues({}, subcategoryMenuTypeItemsIds), subcategoryMenuTypeCombosIds)).map((element) => Number(element)),
          subcategories
        ),
        itemsInMenuType,
        combosInMenuType,
        items,
        combos,
        selectedMenuTypeId,
        categoryId,
        categories
      );
      if (filteredSubcategories.length === 0)
        return filteredCategories;
      return __spreadProps(__spreadValues({}, filteredCategories), {
        [categoryId]: __spreadProps(__spreadValues({}, category), { subcategories: filteredSubcategories })
      });
    },
    {}
  );
};

export { filterMenuCategoriesAndSubCategories, filterSubcategoriesWithItemAndComboIdSet, getHasAllSubcategory, mapSubcategoryFromBucket };
